import { render, staticRenderFns } from "./routePermissionSelect.vue?vue&type=template&id=6b051ae2&scoped=true&"
import script from "./routePermissionSelect.vue?vue&type=script&lang=js&"
export * from "./routePermissionSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b051ae2",
  null
  
)

export default component.exports